import React, { useEffect, useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  communityPathForStatus,
  fetchCommunityMembershipStatus,
} from '../../services/communityMembershipService';

export default function CommunityEntryRedirect() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    if (authLoading) return;
    if (!user) return;

    let cancelled = false;
    (async () => {
      const state = await fetchCommunityMembershipStatus();
      if (cancelled) return;
      if (!state) {
        setError(true);
        return;
      }
      const path = communityPathForStatus(state.status);
      if (state.status === 'none' || state.status === 'rejected') {
        navigate(`${path}#application`, { replace: true });
        return;
      }
      navigate(path, { replace: true });
    })();

    return () => {
      cancelled = true;
    };
  }, [authLoading, navigate, user]);

  if (authLoading) {
    return (
      <div className="dcf-page dcf-page--loading" style={{ alignItems: 'center', justifyContent: 'center' }}>
        <p className="text-sm text-slate-500">Загрузка…</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/private-circle" replace />;
  }

  if (error) {
    return (
      <div className="dcf-auth-gate">
        <h1 className="text-lg font-semibold text-slate-900">Не удалось проверить доступ</h1>
        <p className="mt-3 text-sm text-slate-600">Попробуйте обновить страницу или вернитесь позже.</p>
        <Link to="/private-circle" className="dcf-btn dcf-btn--primary mt-6 inline-flex">
          К странице сообщества
        </Link>
      </div>
    );
  }

  return (
    <div className="dcf-page dcf-page--loading" style={{ alignItems: 'center', justifyContent: 'center' }}>
      <p className="text-sm text-slate-500">Проверяем статус заявки…</p>
    </div>
  );
}
